'use es6';

import I18n from 'I18n';
import { isEmpty } from 'underscore';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { fetchSettingsIfNeeded } from 'forms-utils-lib/settings/actions';
import { getCollectedForm as getCollectedFormFromApi, getSubscriptions as getSubscriptionsFromApi } from 'FormsUI/api/CollectedForms';
import { fetchFormDefinition } from 'FormsUI/actions/FormDefinition';
import { buildForm } from 'FormsUI/actions/FormCreation';
import convertNonHubSpotFormToHubSpotForm from 'FormsUI/actions/formCreation/convertNonHubSpotFormToHubSpotForm';
import getSubscriptionDefinitionsByBusinessUnitId from 'FormsUI/actions/LegalConsent/getSubscriptionDefinitionsByBusinessUnitId';
import { getCollectedForm as getCollectedFormFromSelector, getSubscriptions as getSubscriptionsFromSelector } from 'FormsUI/selectors/CollectedForms';
function createAction(name) {
  return `@@collectedForm/${name}`;
}
export const RESET_REQUEST_STATE = createAction('RESET_REQUEST_STATE');
export const REQUEST_COLLECTED_FORM = createAction('REQUEST_COLLECTED_FORM');
export const SUCCEEDED_COLLECTED_FORM = createAction('SUCCEEDED_COLLECTED_FORM');
export const FAILED_COLLECTED_FORM = createAction('FAILED_COLLECTED_FORM');
export const RECEIVE_COLLECTED_FORM = createAction('RECEIVE_FORM');
export const REQUEST_SUBSCRIPTIONS = createAction('REQUEST_SUBSCRIPTIONS');
export const SUCCEEDED_SUBSCRIPTIONS = createAction('SUCCEEDED_SUBSCRIPTIONS');
export const RECEIVE_SUBSCRIPTIONS = createAction('RECEIVE_SUBSCRIPTIONS');
export const FAILED_SUBSCRIPTIONS = createAction('FAILED_SUBSCRIPTIONS');
export const REQUEST_CONVERT_FORM = createAction('REQUEST_CONVERT_FORM');
export const SUCCEEDED_CONVERT_FORM = createAction('SUCCEEDED_CONVERT_FORM');
export const FAILED_CONVERT_FORM = createAction('FAILED_CONVERT_FORM');
export const SUCCEEDED_RENAMING_COLLECTED_FORM = createAction('SUCCEEDED_RENAMING_COLLECTED_FORM');
export function resetRequestState() {
  return {
    type: RESET_REQUEST_STATE
  };
}
export function requestCollectedForm() {
  return {
    type: REQUEST_COLLECTED_FORM
  };
}
export function receiveCollectedForm(form) {
  return {
    type: RECEIVE_COLLECTED_FORM,
    form
  };
}
export function succeededCollectedForm() {
  return {
    type: SUCCEEDED_COLLECTED_FORM
  };
}
function failedCollectedForm() {
  return {
    type: FAILED_COLLECTED_FORM
  };
}
export function requestSubscriptions() {
  return {
    type: REQUEST_SUBSCRIPTIONS
  };
}
export function succeededSubscriptions() {
  return {
    type: SUCCEEDED_SUBSCRIPTIONS
  };
}
export function receiveSubscriptions(subscriptions, guid) {
  return {
    type: RECEIVE_SUBSCRIPTIONS,
    subscriptions,
    guid
  };
}
function failedSubscriptions() {
  return {
    type: FAILED_SUBSCRIPTIONS
  };
}
function requestConvertForm() {
  return {
    type: REQUEST_CONVERT_FORM
  };
}
function failedConvertForm() {
  return {
    type: FAILED_CONVERT_FORM,
    meta: {
      notification: {
        message: I18n.text('dashboard.table.collectedForms.actions.convertErrorNotification.message'),
        titleText: I18n.text('dashboard.table.collectedForms.actions.convertErrorNotification.titleText'),
        type: 'danger'
      }
    }
  };
}
function succeededConvertForm() {
  return {
    type: SUCCEEDED_CONVERT_FORM
  };
}
export const succeededRenamingCollectedForm = () => ({
  type: SUCCEEDED_RENAMING_COLLECTED_FORM,
  meta: {
    notification: {
      type: 'success',
      message: I18n.text('collectedFormRenameDialog.success.message')
    }
  }
});
function _normalizeFormForConversion(collectedForm, baseNewForm) {
  const newFieldGroups = collectedForm.formFieldGroups.reduce((arr, group) => {
    const newGroup = group.fields.map(field => {
      const newField = Object.assign({}, field, {
        description: ''
      });
      return [{
        fields: [newField]
      }];
    });

    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return [...arr, newGroup];
  }, []);
  const metaData = [...baseNewForm.metaData, {
    name: 'convertedFormId',
    value: collectedForm.guid
  }];
  return Object.assign({}, baseNewForm, {
    metaData,
    formFieldGroups: newFieldGroups,
    formType: FormTypes.HUBSPOT,
    name: `${collectedForm.name} converted`
  });
}
export function fetchCollectedFormIfNeeded(guid) {
  return (dispatch, getState) => {
    const maybeCollectedForm = getCollectedFormFromSelector(getState(), guid);
    if (isEmpty(maybeCollectedForm)) {
      dispatch(requestCollectedForm());
      getCollectedFormFromApi(guid).then(({
        result: collectedForm
      }) => {
        dispatch(succeededCollectedForm());
        dispatch(receiveCollectedForm(collectedForm));
      }, () => {
        dispatch(failedCollectedForm());
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
  };
}
export function fetchSubscriptionsIfNeeded(guid) {
  return (dispatch, getState) => {
    const maybeSubscriptions = getSubscriptionsFromSelector(getState(), guid);
    if (isEmpty(maybeSubscriptions)) {
      dispatch(requestSubscriptions());
      getSubscriptionsFromApi(guid).then(({
        subscriptions
      }) => {
        dispatch(succeededSubscriptions());
        dispatch(receiveSubscriptions(subscriptions, guid));
      }).catch(err => {
        dispatch(failedSubscriptions());
        setTimeout(() => {
          throw err;
        });
      });
    }
  };
}
export const convertForm = (guid, parentId = 0) => (dispatch, getState) => {
  dispatch(requestConvertForm());
  return Promise.all([dispatch(fetchFormDefinition(guid)), dispatch(fetchSettingsIfNeeded()), dispatch(getSubscriptionDefinitionsByBusinessUnitId())]).then(([response]) => {
    const {
      form: collectedFormDefinition
    } = response;
    const baseNewForm = Object.assign({}, buildForm(getState), {
      parentId
    });
    const convertedDefinition = _normalizeFormForConversion(collectedFormDefinition, baseNewForm);
    dispatch(convertNonHubSpotFormToHubSpotForm(convertedDefinition, 1, true)).then(() => {
      dispatch(succeededConvertForm());
    }).catch(() => {
      dispatch(failedConvertForm());
    });
  }).catch(() => {
    dispatch(failedConvertForm());
  });
};